module.exports = __webpack_public_path__ + "static/assets/70f2c54af022b94ba5110641aeca3220.svg";